export default "__VITE_ASSET__eP2v0hFZ__"